import jwtDecode from "jwt-decode";
import useNewGenerateToken from "./GenerateToken";

export const tokenHasExpired = (jwt) => {
  const timestamp = parseInt(jwtDecode(jwt).exp, 10) * 1000;
  return new Date(timestamp).getTime() < new Date().getTime();
};

const useNewValidateToken = () => {
  const { generateRefreshToken } = useNewGenerateToken();

  async function checkTokenExpiry() {
    const sessionID = sessionStorage.getItem("SessionID");
    const token = sessionStorage.getItem("Token");
    const refreshToken = sessionStorage.getItem("RefreshToken");

    if (tokenHasExpired(token)) {
      await generateRefreshToken(sessionID, refreshToken);
    }
  }

  return {
    checkTokenExpiry,
  };
};

export default useNewValidateToken;
